const features = [
  {
    title: "hello@w.xyz",
    body:
      "A unique domain to fit our unique approach to email. W is the only webmail provider with a one-letter email domain — an ultra-premium domain with a natural ending that billions of people worldwide already know by heart.",
  },
  {
    title: "It's Personal",
    body:
      "W lets users create free email addresses with their own domains. Unlike Big Tech, we believe custom email addresses should not be limited to professionals or businesses — and setting one up should never be complicated.",
  },
  {
    title: "The Messenger",
    body:
      "Email doesn't have to be boring. Our mission is to operate a webmail service that offers more ways to connect. With end-to-end encrypted messaging and media updates built directly into your inbox, W is more than an email service, but a social platform with email at its core.",
  },
  {
    title: "The Winbox",
    body:
      "Your new inbox is secure, social, and AI-powered — with smart replies, email summaries, intelligent spam filtering, and more, on demand.",
  },
  {
    title: "Disappearing Mail",
    body:
      "Most inboxes are cluttered with old emails that only take up already limited space. With W, all incoming mail expires 24 hours after opening — unless you choose to save it. Only keep what matters to you.",
  },
  {
    title: "Privacy by Default",
    body:
      "Your Winbox is yours. Your data is completely secured and is not used to train AI models. Unlike Big Tech, privacy isn't a buzzword here — it's the reality.",
  },
];

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 sm:py-32 border-t border-hairline"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-serif-display text-pearl text-3xl sm:text-5xl tracking-tight leading-[1.05]">
            The Next Generation of <span className="italic text-bone">Email</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {features.map((f, i) => (
            <article
              key={f.title}
              data-testid={`feature-card-${i + 1}`}
              className="glass-card glass-card-hover rounded-2xl p-6 sm:p-7 flex flex-col"
            >
              <h3 className="font-serif-display text-pearl text-[22px] sm:text-2xl tracking-tight leading-tight">
                {f.title}
              </h3>
              <p className="mt-3 text-[14px] sm:text-[15px] text-ash leading-relaxed">
                {f.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
